var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 11.2498,
    cy: 10.75,
    r: 9.75,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C17.0749 0 22 4.92514 22 11C22 17.0749 17.0749 22 11 22C4.92514 22 0 17.0749 0 11C0 4.92514 4.92514 0 11 0ZM5.32554 12.1044C4.04164 10.7174 6.1514 8.76304 7.43618 10.1519L9.51672 12.3983L14.5182 6.50122C15.7419 5.0549 17.9427 6.91887 16.7191 8.36348L10.6983 15.4629C10.1303 16.1306 9.13084 16.214 8.51123 15.5445L5.32554 12.1044Z",
    fill: "#18B18B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickcircle);
export default __webpack_public_path__ + "static/media/tickcircle.d08ee5ae2d94c93e7d806d20f5ce2d8d.svg";
export { ForwardRef as ReactComponent };